import { render, staticRenderFns } from "./ImageVertical.vue?vue&type=template&id=bf46f6ae&scoped=true&lang=pug&"
import script from "./ImageVertical.vue?vue&type=script&lang=ts&"
export * from "./ImageVertical.vue?vue&type=script&lang=ts&"
import style0 from "./ImageVertical.vue?vue&type=style&index=0&id=bf46f6ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf46f6ae",
  null
  
)

export default component.exports